module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "movie-view has-header"
  }, [_c('scroller', {
    attrs: {
      "title": "影院热映",
      "type": "hasCover",
      "items": _vm.hotMovies
    }
  }), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "免费在线观影",
      "type": "hasCover",
      "items": _vm.topMovies
    }
  }), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "新片速递",
      "type": "hasCover",
      "items": _vm.newMovies
    }
  }), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "发现好电影",
      "type": "onlyString",
      "items": _vm.movieTags
    }
  }), _vm._v(" "), _c('types'), _vm._v(" "), _c('download-app')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05d2ab4d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MovieView.vue
// module id = 185
// module chunks = 0